export const dictationColumns = [
    {
        key: 'SerialNumber',
        title: 'S.N.',
        formatter: (value, index) => index + 1,
    },
    {
        key: 'VoiceDictationID',
        title: 'Dictation Id',
    },
    {
        key: 'Timestamp',
        title: 'Dictation Date',
        formatter: value => (value ? new Date(value).toLocaleDateString() : 'N/A'),
    },
    {
        key: 'ObjectKey',
        title: 'File Path',
        formatter: value => value.split('/').pop(),
    },
    {
        key: 'StudyID',
        title: 'Study ID',
    },
    {
        title: 'Action',
        key: 'action',
        isAction: true
    },
];
